module.exports = __webpack_public_path__ + "img/06.363cda8c.jpg";